/**
 * Created by Ivan on 09.03.2026
 */

const HungryGamesLogic = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.mission = mission;

    const details = mission.details || {};
    this.state = details.state !== undefined ? details.state : HungryGamesLogic.STATES.IDLE;
    this.competitionStart = details.competitionStart;
    this.lostTime = details.lostTime;

    const statistics = cleverapps.dataLoader.load(DataLoader.TYPES.HUNGRY_GAMES_STATISTICS) || {};
    this.unlocks = statistics.unlocks || 0;
    this.totalPoints = statistics.totalPoints || 0;

    this.eliminationRate = details.rate || HungryGamesLogic.generateEliminationRate();

    this.createPlayers();

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.result}`, once: true });
    }
};

HungryGamesLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
HungryGamesLogic.prototype.constructor = HungryGamesLogic;

HungryGamesLogic.prototype.onUpdateState = function () {
    if (this.updateStateTimeout) {
        cleverapps.timeouts.clearTimeout(this.updateStateTimeout);
        this.updateStateTimeout = undefined;
    }

    if (this.state === HungryGamesLogic.STATES.FINISHED) {
        this.mission.complete();
        return;
    }

    let timeLeft;
    if (this.state === HungryGamesLogic.STATES.ACTIVE) {
        timeLeft = this.competitionStart + HungryGamesLogic.COMPETITION_DURATION - Date.now();
        if (timeLeft <= 0) {
            this.loseCompetition();
            return;
        }
    } else if (this.state === HungryGamesLogic.STATES.LOST) {
        timeLeft = this.getCooldownTimeLeft();
        if (timeLeft <= 0) {
            this.lostTime = undefined;
            this.competitionStart = undefined;
            this.mission.setResult(0, undefined, true);
            this.setState(HungryGamesLogic.STATES.IDLE);
            return;
        }
    }

    if (timeLeft > 0) {
        this.updateStateTimeout = cleverapps.timeouts.setTimeout(this.onUpdateState.bind(this), timeLeft);
    }
};

HungryGamesLogic.prototype.stop = function () {
    if (this.updateStateTimeout) {
        cleverapps.timeouts.clearTimeout(this.updateStateTimeout);
        this.updateStateTimeout = undefined;
    }
};

HungryGamesLogic.prototype.isRunning = function () {
    return this.state === HungryGamesLogic.STATES.ACTIVE;
};

HungryGamesLogic.prototype.canRestart = function () {
    const timeLeft = Math.max(0, this.mission.started + HungryGamesLogic.COMPETITION_DURATION - Date.now());
    return timeLeft > HungryGamesLogic.COOLDOWN_DURATION;
};

HungryGamesLogic.prototype.competitionTimeLeft = function () {
    if (this.state === HungryGamesLogic.STATES.ACTIVE) {
        return Math.max(0, this.competitionStart + HungryGamesLogic.COMPETITION_DURATION - Date.now());
    }

    if (this.state === HungryGamesLogic.STATES.LOST) {
        return this.getCooldownTimeLeft();
    }

    return undefined;
};

HungryGamesLogic.prototype.getCooldownTimeLeft = function () {
    if (this.state === HungryGamesLogic.STATES.LOST && this.lostTime) {
        return Math.max(0, this.lostTime + HungryGamesLogic.COOLDOWN_DURATION - Date.now());
    }
    return 0;
};

HungryGamesLogic.prototype.startCompetition = function () {
    if (this.state !== HungryGamesLogic.STATES.IDLE) {
        return;
    }

    const forceShown = cleverapps.forces.isShown(Forces.HUNGRY_GAMES);

    this.competitionStart = Date.now();
    this.mission.setResult(0, undefined, true);
    this.setState(HungryGamesLogic.STATES.ACTIVE);
    this.startLevel();

    this.unlocks++;
    this.saveStatistics();
    this.logEvent(Mission.EVENTS.MISSION_UNLOCKED, { once: true });

    if (this.unlocks > 1) {
        this.logEvent(Mission.EVENTS.MISSION_PROLONGATION);
    }

    cleverapps.focusManager.display({
        focus: "HungryGamesStartCompetition",
        stack: true,
        actions: [
            function (f) {
                new HungryGamesStartCompetitionWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                cleverapps.missionManager.trigger("hungryGamesCompetitionStarted", this.mission);
                f();
            },
            (f) => {
                if (!forceShown) {
                    cleverapps.tutorial.startScenario(HungryGamesTutorial(this.mission));
                    f();
                } else {
                    new HungryGamesWindow(this.mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            },
            (f) => {
                const sourceTutorial = cleverapps.tutorial.findScenario("hungry_games_source_tutorial");
                if (sourceTutorial && sourceTutorial.isAvailable() && !forceShown) {
                    cleverapps.tutorial.startScenario(sourceTutorial);
                }
                f();
            }
        ]
    });
};

HungryGamesLogic.prototype.startLevel = function () {
    this.trigger("levelStarted");
};

HungryGamesLogic.prototype.loseCompetition = function () {
    this.previousLevel = this.mission.result;
    this.needShowLoseWindow = true;

    if (!this.canRestart()) {
        this.setState(HungryGamesLogic.STATES.FINISHED);
        this.mission.complete();
        cleverapps.missionManager.trigger("hungryGamesLose", this.mission);
        return;
    }

    this.lostTime = Date.now();
    this.setState(HungryGamesLogic.STATES.LOST);

    cleverapps.missionManager.trigger("hungryGamesLose", this.mission);
};

HungryGamesLogic.prototype.getOrderRewards = function (order) {
    if (order.eventOrder && order.eventOrder instanceof HungryGamesOrder && this.state === HungryGamesLogic.STATES.ACTIVE) {
        return {
            missionType: this.mission.type,
            amount: 1
        };
    }
};

HungryGamesLogic.prototype.save = function (details) {
    details.state = this.state;
    details.competitionStart = this.competitionStart;
    details.lostTime = this.lostTime;
    details.rate = this.eliminationRate;
};

HungryGamesLogic.prototype.logEvent = function (event, options) {
    if (Date.now() < this.mission.started) {
        return;
    }
    this.mission.logEvent(event, options);
};

HungryGamesLogic.prototype.logMissionAction = function () {
    if (this.mission.result === 1) {
        this.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });
    }
};

HungryGamesLogic.prototype.onUpdateMission = function (delta) {
    if (delta === 0) {
        return;
    }

    this.previousLevel = this.mission.result - delta;
    this.totalPoints++;
    this.saveStatistics();

    this.logEvent(Mission.EVENTS.MISSION_PROGRESS, { value: 1 });
    this.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.result}` });

    if (this.mission.result >= HungryGamesLogic.LEVELS_AMOUNT) {
        cleverapps.missionManager.trigger("hungryGamesWin", this.mission);
        this.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.competitionStart = undefined;
        this.setState(HungryGamesLogic.STATES.FINISHED);
        this.mission.complete();
        return;
    }

    this.startLevel();
    this.trigger("levelAdvanced");

    cleverapps.missionManager.trigger("hungryGamesLevelAdvanced", this.mission);
};

HungryGamesLogic.prototype.showAdvanceWindow = function () {
    this.needShowAdvanceWindow = false;

    cleverapps.focusManager.display({
        focus: "HungryGamesAdvanceLevel",
        action: (f) => {
            new HungryGamesWindow(this.mission);
            cleverapps.focusManager.onceNoWindowsListener = () => {
                cleverapps.missionManager.trigger("hungryGamesStartNextOrder", this.mission);
                f();
            };
        }
    });
};

HungryGamesLogic.prototype.onComplete = function () {
    if (this.mission.result < HungryGamesLogic.LEVELS_AMOUNT || this.mission.rewardsReceived) {
        return;
    }

    const winners = this.calcPlayersForLevel(HungryGamesLogic.LEVELS_AMOUNT);
    const reward = RewardsConfig.HungryGames;
    const amount = Math.floor(reward.value / winners);

    cleverapps.focusManager.display({
        focus: "HungryGamesWin",
        stack: true,
        actions: [
            (f) => {
                cleverapps.timeouts.setTimeout(f, 2000);
            },
            (f) => {
                new HungryGamesWindow(this.mission);
                cleverapps.timeouts.setTimeout(() => {
                    this.trigger("closeWindow");
                }, 3000);
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                this.mission.rewardsReceived = true;
                this.mission.onChanged();

                this.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
                    value: amount
                });
                this.mission.logDailyReward();

                new HungryGamesRewardWindow(this.mission, {
                    reward: { [reward.type]: amount },
                    amount,
                    winners
                });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        ]
    });
};

HungryGamesLogic.prototype.showLoseWindow = function () {
    cleverapps.focusManager.display({
        focus: "HungryGamesLost",
        actions: [
            (f) => {
                new HungryGamesWindow(this.mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        ]
    });
};

HungryGamesLogic.prototype.getFinishWindow = function () {
    return this.needShowLoseWindow ? HungryGamesWindow : undefined;
};

HungryGamesLogic.prototype.canRemoveSilently = function () {
    return this.mission.result >= HungryGamesLogic.LEVELS_AMOUNT;
};

HungryGamesLogic.prototype.calcPlayersForLevel = function (level) {
    return Math.round(HungryGamesLogic.PLAYERS_AMOUNT * Math.pow(this.eliminationRate, level));
};

HungryGamesLogic.prototype.calcPlayers = function () {
    return this.calcPlayersForLevel(this.mission.result);
};

HungryGamesLogic.prototype.calcShownPlayers = function () {
    if (this.state === HungryGamesLogic.STATES.IDLE || this.state === HungryGamesLogic.STATES.LOST) {
        return undefined;
    }

    const level = this.previousLevel !== undefined ? this.previousLevel : this.mission.result;
    return this.calcPlayersForLevel(level);
};

HungryGamesLogic.prototype.onAdvanceShown = function () {
    this.previousLevel = undefined;
    this.needShowLoseWindow = undefined;
    this.trigger("advanceShown");
};

HungryGamesLogic.prototype.getView = function () {
    if (this.state === HungryGamesLogic.STATES.ACTIVE) {
        return HungryGamesWindow;
    }

    if (this.state === HungryGamesLogic.STATES.LOST) {
        return HungryGamesCooldownWindow;
    }

    return HungryGamesStartWindow;
};

HungryGamesLogic.prototype.setState = function (state) {
    this.state = state;
    this.mission.setResult(this.mission.result, undefined, true);

    if (state === HungryGamesLogic.STATES.FINISHED) {
        const averagePoints = this.unlocks > 0 ? Math.round(this.totalPoints / this.unlocks) : 0;
        this.logEvent(Mission.EVENTS.MISSION_POINTS, { value: averagePoints });
        cleverapps.dataLoader.remove(DataLoader.TYPES.HUNGRY_GAMES_STATISTICS);
    }

    this.trigger("updateState");
    this.mission.onUpdateState();
};

HungryGamesLogic.prototype.saveStatistics = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.HUNGRY_GAMES_STATISTICS, {
        unlocks: this.unlocks,
        totalPoints: this.totalPoints
    });
};

HungryGamesLogic.prototype.getTimeLeft = function () {
    if (this.state === HungryGamesLogic.STATES.FINISHED) {
        return 0;
    }

    return this.mission.getTimeLeft();
};

HungryGamesLogic.prototype.createPlayers = function () {
    this.players = cleverapps.bots.listBots(HungryGamesLogic.PLAYERS_AMOUNT - 1);

    this.user = {
        id: connector.platform.getUserID(),
        name: cleverapps.user.getPlayerInfo().name,
        avatar: cleverapps.user.getPlayerInfo().avatar,
        user: true
    };

    cleverapps.UI.Avatar.preload(this.players.concat([this.user]));
};

HungryGamesLogic.prototype.isAttentionRequired = function () {
    return this.state === HungryGamesLogic.STATES.IDLE;
};

HungryGamesLogic.prototype.calcStatusInfo = function () {
    if (this.state === HungryGamesLogic.STATES.IDLE || this.state === HungryGamesLogic.STATES.LOST) {
        return undefined;
    }

    return {
        sidebarTitle: `${this.mission.result}/${HungryGamesLogic.LEVELS_AMOUNT}`
    };
};

HungryGamesLogic.STATES = {
    IDLE: 0,
    ACTIVE: 1,
    LOST: 2,
    FINISHED: 3
};

HungryGamesLogic.COMPETITION_DURATION = cleverapps.parseInterval("24 hours");
HungryGamesLogic.COOLDOWN_DURATION = cleverapps.parseInterval("30 minutes");
HungryGamesLogic.LEVELS_AMOUNT = 7;
HungryGamesLogic.PLAYERS_AMOUNT = 100;

HungryGamesLogic.generateEliminationRate = function () {
    const winners = 1 + Math.floor(Math.pow(Math.random(), 0.74) * 15);
    return Math.pow(winners / HungryGamesLogic.PLAYERS_AMOUNT, 1 / HungryGamesLogic.LEVELS_AMOUNT);
};
